import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

import { PITEventService } from '../../event/pit.event.service';
import { ConfigService, IConfigService } from '../../configuration/services/config.service';
import { ILoggingService, LoggingService } from '../../logging/logging.service';
import { BaseService } from '../../services/misc/base.service';
import { IRoutingService, RoutingService } from '../../services/misc/routing.service';
import { UtilsMisc } from '../../utils/utils.misc';
import { UtilsString } from '../../utils/utils.string';
import { IApplicationService, IAppPage } from '../interfaces/application.service.interface';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService extends BaseService implements IApplicationService {

  protected _appPages: IAppPage[] = [];
  protected _isBusy$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  protected isBusyCount = 0;

  constructor(configurationService: ConfigService, loggingService: LoggingService, protected routingService: RoutingService, protected eventService: PITEventService) {
    super(configurationService, loggingService, false);

    this.doInitializeEvents();

    this.loggingService.debug('ApplicationService --> constructor()');
  }

  public get appPages(): IAppPage[] {
    return this._appPages;
  }

  public applicationTitle: string = null;

  public headerCaption?: string = null;

  public get isBusy(): boolean {
    return this.isBusySubject.getValue();
  }

  public set isBusy(value: boolean) {
    if (value === true) {
      this.isBusyCount = this.isBusyCount + 1;
    } else if (this.isBusyCount > 0) {
      this.isBusyCount = this.isBusyCount - 1;
    }
    if (this.isBusyCount > 0) {
      this.isBusySubject.next(true);
    } else {
      this.isBusySubject.next(false);
    }
    /*if (value !== this.isBusy) {
        this.setIsBusyAsync(value);
    }*/
  }

  public readonly isBusySubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public readonly isBusy$: Observable<boolean> = this.isBusySubject.asObservable();

  public selectedPage: IAppPage = null;

  public getConfigurationService(): IConfigService {
    return this.configurationService;
  }

  public getLoggingService(): ILoggingService {
    return this.loggingService;
  }

  public getRoutingService(): IRoutingService {
    return this.routingService;
  }

  public async navigateToAsync(path: string, params: any = null): Promise<void> {
    await this.routingService.routeToAsync(path);
  }

  public async navigateToAppPageAsymc(appPage: IAppPage): Promise<void> {
    if (UtilsMisc.isNullOrUndefined(appPage.method) === false) {
      await appPage.method();
    } else {
      await this.routingService.routeToAsync(appPage.url);
    }
  }

  public parseError(error: any): string {
    return this.doParseError(error);
  }

  public async setIsBusyAsync(value: boolean, text: string = null): Promise<void> {
    /*if (value === true) {
        this._loadingService = await this.loadingController.create({
            showBackdrop: true
        });
        this.loadingService.message = text;
        await this.loadingService.present();
        this.isBusy$.next(true);
        await this.waitAsync(100);
    } else {
        if (this._loadingService !== null) {
            await this.loadingService.dismiss();
            this._loadingService = null;
            this.isBusy$.next(false);
            await this.waitAsync(100);
        }
    }*/
  }

  public async setPagesAsync(): Promise<void> {
    await this.doSetPagesAsync();
  }

  public async showErrorAsync(errorMessages: string[]): Promise<void> {
    return (await this.doShowErrorAsync(errorMessages));
  }

  public subscribeForBusyChange(method: (value: boolean) => void): Subscription {
    return this.isBusy$.subscribe(value => method(value));
  }

  public async waitAsync(value: number): Promise<void> {
    await UtilsMisc.waitAsync(value);
  }

  /*protected get loadingService(): HTMLIonLoadingElement {
      return this._loadingService;
  }*/

  protected doInitializeEvents(): void {
    this.eventService.subscribeForEvent('application', this.handleApplicationEventAsync.bind(this));

    this.eventService.registerMethod('busy', (value: boolean) => {
      this.eventService.sendEvent('application', {
        type: 'busy',
        value: value
      });
    });
    this.eventService.registerMethod('busy.on', () => {
      this.eventService.sendEvent('application', {
        type: 'busy',
        value: true
      });
    });
    this.eventService.registerMethod('busy.off', () => {
      this.eventService.sendEvent('application', {
        type: 'busy',
        value: false
      });
    });
  }

  protected doParseError(error: any): string {
    let result: string = null;

    if (UtilsMisc.isNullOrUndefined(error.error) === false) {
      if (UtilsString.stringIsNullOrEmpty(error.error.errorMessage) === false) {
        result = error.error.errorMessage;
      } else if (UtilsString.stringIsNullOrEmpty(error.error.exception) === false) {
        result = error.error.exception;
      }
    } else if (UtilsMisc.isNullOrUndefined(error.statusText) === false) {
      result = error.statusText;
    }

    return result;
  }

  protected async doSetPagesAsync(): Promise<void> {
  }

  protected async doShowErrorAsync(errorMessages: string[]): Promise<void> {
  }

  protected async doHandleApplicationEventAsync(event: any): Promise<void> {
    const eventType: string = event.type;
    switch (eventType) {
      case 'busy': {
        this.isBusy = (event.value as boolean);
        break;
      }
      case 'init': {
        await this.handleApplicationEventInit(event);
        break;
      }
    }
  }

  protected async handleApplicationEventAsync(event: any): Promise<void> {
    await this.doHandleApplicationEventAsync(event);
  }

  protected async handleApplicationEventInit(event: any): Promise<void> {
    await this.setPagesAsync();
  }

}
